<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                  <div class="row"></div>
                    <div class="" style="width:100%; padding: 20px">
                      <div v-if="isWufooLoading" class="text-center">
                          <page-loader></page-loader>
                      </div>
                      <div id="wufoo-k7u0thh08lm2zg" v-else></div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: ["Account"],
  components: {PageLoader},
  data() {
    return {
      isModalShown: true
    }
  },
  methods: {
    CloseModal() {
      this.$emit('closeWufoo');
    },
    ShowWufoo(salesforceId) {
      var _this = this;
      var k7u0thh08lm2zg;(function(d, t) {
      var s = d.createElement(t), options = {
      'userName':'evf',
      'formHash':'k7u0thh08lm2zg',
      'autoResize':true,
      'height':'580',
      'async':true,
      'host':'wufoo.com',
      'header':'show',
      'ssl':true,
      'defaultValues':'field15=TRUE&field13='+ salesforceId +'&field9='+ _this.Account.emailAddress};
      s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js';
      s.onload = s.onreadystatechange = function() {
      var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return;
      try { k7u0thh08lm2zg = new WufooForm();k7u0thh08lm2zg.initialize(options);k7u0thh08lm2zg.display(); } catch (e) {}};
      var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);
      })(document, 'script');
      this.isWufooLoading = false;
    }
  },
  created() {
    this.isWufooLoading = true;
    var portalUserSalesforceId = localStorage.getItem("portalUserSalesforceId");
    this.ShowWufoo(portalUserSalesforceId);
  },
};
</script>


// WEBPACK FOOTER //
// HelpForm.vue?8f8495d0